import axios from "axios";

export const api = axios.create({
  baseURL: process.env.REACT_APP_BE_BASE_URL,
});

api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("humanToken");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      sessionStorage.removeItem("humanToken");
      window.location.reload();
    }

    return Promise.reject(error);
  }
);